import React, { useState, useEffect } from 'react';
import TextField from './fields/TextField';
import NumberField from './fields/NumberField';
import DateField from './fields/DateField';
import AsyncSelectField from './fields/AsyncSelectField';
import SelectField from './fields/SelectField';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SearchBox.css';
import SearchableDropdown from './fields/SearchableDropdown';
import FieldWrapper from './fields/FieldWrapper';
import lodash from 'lodash';
import { toast } from 'react-toastify';
import { FaCopy, FaUpload } from 'react-icons/fa';
import Modal from 'react-modal';
import MessageBus from './../Messagebus'; // Import the message bus
import InclusionExclusionField from './fields/InclusionExclusionField';

Modal.setAppElement('#root'); // Adjust this selector based on your app structure

const SearchBox = (props) => {
  const { searchBoxJson = {}, onSearch, onCancel, fetchingForm = false, updatedValues/*: updatedValuesProps*/ = {}, fetchingList = false, buttonsDisabled = false } = props;
  const { data = {}, meta: globalMeta = {} } = searchBoxJson;
  const { submitButtonLabel = 'Search', copyPayloadButton = false, loadPayloadButton = false, preExecuteRules = false, enableCancelSubmit = false } = globalMeta;
  const { section = [], label = '' } = data;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modelButtonLoader, setModelButtonLoader] = useState(false);
  const [jsonInput, setJsonInput] = useState('');

  const [formData, setFormData] = useState({});
  // const [updatedValues, setUpdatedValues] = useState(updatedValuesProps);
  const [initialized, setInitialized] = useState(false);

  const initializeSectionData = (section, addSection = false) => {
    const { isDynamic = false, fields = [], defaultLength = 1 } = section || {};
    const fieldJson = fields.reduce((accum, field) => {
      if (field.value !== null && field.value !== undefined)
        return { ...accum, [field.id]: field.value };
      return accum;
    }, {});
    if (isDynamic) {
      const _length = addSection ? 1 : defaultLength;
      const value = [];
      // if (addSection) {
      for (let index = 0; index < _length; index++)
        value.push(fieldJson);
      // }
      return value;
    } else {
      return fieldJson;
    };
  }

  useEffect(() => {
    // console.log("SearchBox-useEffect[updatedValues]", updatedValues, preExecuteRules);
    if (!lodash.isEmpty(updatedValues)) {
      setInitialized(false);
      setFormData(updatedValues);
      setInitialized(true);
      if (preExecuteRules) {
        executeRules();
      }
    }
  }, [updatedValues]);

  // useEffect(() => {
  //   // console.log("SearchBox-useEffect[preExecuteRules]", preExecuteRules);
  //   if (preExecuteRules) {
  //     executeRules();
  //   }
  // }, [preExecuteRules]);

  const processRulesWithTimeout = async (rule, delay = 500) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(rule);
      }, delay);
    });
  };

  const executeRules = async () => {
    await processRulesWithTimeout({}, 500);
    MessageBus.publish('executeRules', {});
    await processRulesWithTimeout({}, 500);
    if (!lodash.isEmpty(updatedValues)) {
      setFormData(updatedValues);
    }
  }

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setModelButtonLoader(false);
  };

  const handleJsonChange = (e) => {
    setJsonInput(e.target.value);
  };

  const initializeFormData = () => {
    if (section.length <= 1) {
      return initializeSectionData(section[0]);
    }
    return section.reduce((accum, section) => {
      const data = initializeSectionData(section);
      return { ...accum, [section.id]: data };
    }, {});
  };

  useEffect(() => {
    // console.log("SearchBox-useEffect[searchBoxJson]", searchBoxJson, updatedValues);
    setInitialized(false);
    let formJson = updatedValues;
    if (lodash.isEmpty(updatedValues)) {
      formJson = initializeFormData()
    }
    if (!lodash.isEmpty(formJson)) {
      // console.log("setFormData done", formJson);
      setFormData(formJson);
      if (preExecuteRules) {
        executeRules();
      }
    }

    setInitialized(true);
  }, [searchBoxJson]);


  const handleInputChange = (sectionId, fieldId, value, index = null) => {
    setFormData((prevFormData) => {
      const isSingleSection = section.length === 1;
      if (isSingleSection) {
        if (index === null) {
          return { ...prevFormData, [fieldId]: value };
        } else {
          let _data = [...prevFormData];
          _data[index][fieldId] = value;
          return _data;
        }
      } else {
        if (index === null) {
          const _data = prevFormData[sectionId] || {};
          return {
            ...prevFormData,
            [sectionId]: {
              ..._data, [fieldId]: value
            }
          };
        } else {
          const newData = (prevFormData[sectionId] || []).map((_data, _index) => {
            if (index === _index) {
              return { ..._data, [fieldId]: value }
            }
            return { ..._data };
          })
          return { ...prevFormData, [sectionId]: newData };
        }
      }
    });

  };

  const renderField = (sectionId, field, index = null, _formData) => {
    const {
      id,
      label,
      name,
      type,
      options,
      labelSize,
      placeholder,
      required,
      disabled,
      hidden,
      isDynamic,
      size = '3', // Default size to 3 if not provided
      searchable,
      multiple,
      rules = [],
      step,
      showCurrency,
      format,
      hint,
      showCronDescription,
    } = field;

    // console.log("field", sectionId, field.id, _formData);

    const commonProps = {
      id, index,
      sectionId,
      label: label || name,
      name,
      hint,
      placeholder: placeholder || name,
      options, step,
      value: _formData ? _formData[id] : undefined,
      onChange: (fieldId, value) =>
        handleInputChange(sectionId, fieldId, value, index),
      labelClass:
        labelSize === 'tiny'
          ? 'form-label small text-muted'
          : labelSize === 'small'
            ? 'form-label small'
            : 'form-label',
      disabled, hidden,
      required, isDynamic,
      searchable, multiple,
      rules, size, format,
      showCurrency,
      showCronDescription
    };

    const Component = {
      text: TextField,
      number: NumberField,
      date: DateField,
      searchableDropdown: SearchableDropdown,
      asyncSelect: AsyncSelectField,
      select: SelectField,
      inclusionExclusion: InclusionExclusionField
    }[type];

    if (!Component) return null;

    return (<FieldWrapper component={Component} {...commonProps} />);
  };

  const removeDynamicSection = (_section, index) => {
    const { id = '' } = _section;
    let data = section.length === 1 ? [...formData] : [...(formData[id] || [])];
    data.splice(index, 1);
    if (section.length === 1)
      setFormData(data);
    else
      setFormData({ ...formData, [id]: data });
  }

  const addDynamicSection = (_section) => {
    const { id = '' } = _section;
    if (section.length === 1)
      setFormData([...formData, ...initializeSectionData(_section, true)]);
    else
      setFormData({ ...formData, [id]: [...formData[id] || [], ...initializeSectionData(_section, true)] });
  }

  const renderSection = (section, sectionFormData) => {
    // console.log("section", section);
    const { id, label: sectionLabel, fields: sectionFields = [], isDynamic = false, defaultLength = 1 } = section;
    const _sectionFormData = isDynamic ? sectionFormData || [] : [sectionFormData];
    // console.log("Section: ", id, sectionFormData, formData);
    return (
      <div key={id} className="mb-4">
        <h6 style={{ fontWeight: '600', textAlign: 'left', color: 'rgb(235, 148, 34)' }}>
          {sectionLabel}
        </h6>
        {_sectionFormData.map((_, index) => (
          <div key={`${id}-${index}`} className="border p-3 rounded mb-3">
            <div className="row">
              {sectionFields.map((field) => renderField(id, field, isDynamic ? index : null, _))}
            </div>
            {isDynamic ? <div className="d-flex justify-content-end">
              {sectionFormData.length > defaultLength && (
                <button
                  type="button"
                  className="btn btn-danger btn-sm me-2"
                  onClick={() => removeDynamicSection(section, index)}
                >
                  Remove
                </button>
              )}
            </div> : ''}
          </div>
        ))}
        {isDynamic ? <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={() => addDynamicSection(section)}
        >
          Add {sectionLabel}
        </button> : ''}
      </div>
    );
  };

  const handleSubmit = (e) => {
    // console.log("formData", formData);
    e.preventDefault();
    onSearch(formData);
  };

  const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(textArea);
    return copied;
  };

  const handleCopyToClipboard = async () => {
    const formDataString = JSON.stringify(formData, null, 2);
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(formDataString);
        toast.success('Form data copied');
        return;
      }
      const copied = fallbackCopyToClipboard(formDataString);
      if (copied) {
        toast.success('Form data copied');
      } else {
        toast.error('Failed to copy form data');
      }
    } catch (err) {
      const copied = fallbackCopyToClipboard(formDataString);
      if (copied) {
        toast.success('Form data copied');
      } else {
        toast.error('Failed to copy: ' + err);
      }
    }
  };

  const isLoading = lodash.isEmpty(searchBoxJson) || lodash.isEmpty(data);

  const handleModalButtonClick = async () => {
    try {
      setModelButtonLoader(true);
      const parsedJson = JSON.parse(jsonInput);
      await processRulesWithTimeout({}, 500);
      setFormData(parsedJson);
      await processRulesWithTimeout({}, 500);
      MessageBus.publish('executeRules', {});
      await processRulesWithTimeout({}, 500);
      setFormData(parsedJson);
      setJsonInput('');
      handleCloseModal();
    } catch (err) {
      toast.error('Error parsing JSON' + err);
      setModelButtonLoader(false);
    }
  }


  // console.log("formData", formData);
  return (
    <div className="search-box-container bg-light p-4 rounded shadow-sm">
      {(!initialized || isLoading || fetchingForm) ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {label ? <h5
            className="search-box-heading text-primary mb-4"
            style={{ fontWeight: '600' }}
          >
            {label}
          </h5> : ''}
          <form onSubmit={handleSubmit}>
            {section.map(_section =>
              renderSection(_section, section.length === 1 ? formData : formData[_section.id])
            )}
            <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap search-box-actions">
              {loadPayloadButton ?
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => { setModalIsOpen(true); }}
                  title='Load Form'
                >
                  <FaUpload />
                </button>
                : ''}
              {copyPayloadButton ?
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCopyToClipboard}
                  title='Copy Form'
                >
                  <FaCopy />
                </button>
                : ''}
              <button type="submit" className="btn btn-primary" disabled={fetchingList || buttonsDisabled}>
                {!fetchingList ?
                  submitButtonLabel :
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }
              </button>
              {enableCancelSubmit && fetchingList ?
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                : ''}
            </div>
          </form>

        </>
      )}
      {/* React Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Form Data"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
          },
          content: {
            width: 'min(600px, calc(100vw - 32px))',
            margin: 'auto',
            padding: '20px',
          },
        }}
      >
        {/* <button onClick={handleCloseModal} style={{ float: 'right' }}>
          <FaTimes />
        </button> */}
        <h2>JSON Input</h2>
        <textarea
          value={jsonInput}
          onChange={handleJsonChange}
          style={{ width: '100%', height: '300px' }}
        />
        <button
          type="button"
          className="btn btn-primary mt-4"
          onClick={handleModalButtonClick}
          disabled={modelButtonLoader}
        >
          <FaUpload className="me-2" />
          {!modelButtonLoader ?
            'Load JSON' :
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        </button>
      </Modal>
    </div>
  );
};

export default SearchBox;
